import Layout from "components/layout";
import React from "react";

import { Navigate, useLocation } from "react-router-dom";

export const AuthMiddleware = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem("authUser");

  // if (!isAuthenticated) {
  //   return <Navigate to="/login" state={{ from: location }} replace />;
  // }

  // Default admin layout for all authenticated pages
  return <Layout>{children}</Layout>;
};

// For public routes
export const PublicRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("authUser");
  const location = useLocation();

  const isAllowedPublicPage = "";

  if (isAuthenticated && location.pathname !== "/" && !isAllowedPublicPage) {
    return <Navigate to="/dashboards" replace />;
  }

  return children;
};
